import React, { useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles, Theme, Grid, Typography } from '@material-ui/core';
import AssetVO from 'commons/vo/AssetVO';
import { RootState } from 'redux/reducers/type';
import { LoginBackground, TestTeam1, TestTeam2 } from 'asset/images';
import TeamVO from 'commons/vo/TeamVO';
import { FooterMobileLogo, VersusMobileIcon } from 'asset/images';
import { useStyles } from 'components/Score';
import clsx from 'clsx';

function ScoreHeader() {
  const classes = useStyles();
  const { selectedAsset, selectedTeam1, selectedTeam2 } = useSelector(
    (state: RootState) => state.asset,
  );

  // const isShow = useMemo(() => {
  //   let isShowTeam = true;

  //   if (selectedTeam1 && selectedTeam2) {
  //     const { forcedHideTeam, forcedShowTeam } = config;
  //     const team1Id = selectedTeam1.id;
  //     const team2Id = selectedTeam2.id;
  //     const isForcedHide = forcedHideTeam.findIndex(id => id === team1Id || id === team2Id) !== -1;
  //     const isForcedShow = forcedShowTeam.findIndex(id => id === selectedAsset.gameType) !== -1;

  //     if (isForcedHide) {
  //       isShowTeam = false;
  //     }

  //     if (isForcedShow) {
  //       isShowTeam = true;
  //     }
  //   }
  //   return isShowTeam;
  // }, [config.forcedHideTeam, config.forcedShowTeam, selectedTeam1, selectedTeam2]);

  const team1Score = useMemo(() => {
    if (selectedAsset) {
      return selectedAsset.team1Score;
    }
    return 0;
  }, [selectedAsset]);

  const team2Score = useMemo(() => {
    if (selectedAsset) {
      return selectedAsset.team2Score;
    }
    return 0;
  }, [selectedAsset]);

  const team1LogoPath = useMemo(() => {
    if (!selectedTeam1) {
      return '';
    }
    return selectedTeam1 !== null ? selectedTeam1.getTeamLogoDbPath() : '';
  }, [selectedTeam1]);

  const team2LogoPath = useMemo(() => {
    // if (selectedAsset && selectedTeam2) {
    //   return selectedTeam2.getTeamLogoPath(selectedAsset.symbolicPath);
    // }
    if (!selectedTeam2) {
      return '';
    }
    return selectedTeam2 !== null ? selectedTeam2.getTeamLogoDbPath() : '';
  }, [selectedTeam2]);

  const onErrorImage = useCallback(event => {
    event.currentTarget.src = FooterMobileLogo;
  }, []);

  return (
    <Grid container justifyContent="center" alignItems="center" className={classes.root}>
      {/* [team 1] 홈 팀 */}
      <Grid item xs={4} className={classes.scoreContainer}>
        <img src={team1LogoPath} className={classes.teamLogo} onError={onErrorImage} />
        <Typography className={clsx(classes.teamScore)}>{team1Score}</Typography>
      </Grid>
      <Grid item xs={2} className={clsx(classes.scoreContainer, classes.versusContainer)}>
        <img src={VersusMobileIcon} />
      </Grid>
      {/* [team 2] 어웨이 팀 */}
      <Grid item xs={4} className={classes.scoreContainer}>
        <img src={team2LogoPath} className={classes.teamLogo} onError={onErrorImage} />
        <Typography className={clsx(classes.teamScore)}>{team2Score}</Typography>
      </Grid>
    </Grid>
  )
}

export default ScoreHeader;
